import React from 'react'

function EducationItem({icon, text1, text2, text3, title}) {
    return (
        <div className="EducationItem">
            <div className="education">
                <div className="years">
                    <p>2016-2020</p>
                </div>
                
                <div className="right-items">
                     
                    <h6>{title}</h6>
                    <p>{text1}</p>
                    
                    <p>{text2}</p>
                    <p>{text3}</p>
                </div>
            </div>
        </div>
    )
}

export default EducationItem;